import { c as _c } from "react/compiler-runtime";
import { getHostedOnboardingConfig } from '@onefootprint/fetch-hosted';
import type { RequestError } from '@onefootprint/request';
import type { GetHostedOnboardingConfigResponse } from '@onefootprint/request-types';
import type { ObConfigAuth } from '@onefootprint/types';
import { AUTH_HEADER } from '@onefootprint/types';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
export type GetOnboardingConfigRequest = {
  obConfigAuth?: ObConfigAuth;
  authToken?: string;
};
const useGetOnboardingConfig = (payload, t0) => {
  const $ = _c(21);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    obConfigAuth,
    authToken
  } = payload;
  let t2;
  let t3;
  if ($[2] !== authToken || $[3] !== obConfigAuth) {
    t2 = ["get-onboarding-config", obConfigAuth, authToken];
    t3 = () => getHostedOnboardingConfig({
      headers: obConfigAuth ?? {
        [AUTH_HEADER]: authToken
      }
    });
    $[2] = authToken;
    $[3] = obConfigAuth;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  const t4 = !!obConfigAuth || !!authToken;
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      retry: 2
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const query = useQuery(t5);
  let t6;
  if ($[10] !== options || $[11] !== query.data || $[12] !== query.error || $[13] !== query.isError || $[14] !== query.isSuccess) {
    t6 = () => {
      if (query.isSuccess && options.onSuccess) {
        options.onSuccess(query.data.data);
      }
      if (query.isError && options.onError) {
        options.onError(query.error as RequestError);
      }
    };
    $[10] = options;
    $[11] = query.data;
    $[12] = query.error;
    $[13] = query.isError;
    $[14] = query.isSuccess;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== query.data || $[17] !== query.error || $[18] !== query.isError || $[19] !== query.isSuccess) {
    t7 = [query.isSuccess, query.isError, query.data, query.error];
    $[16] = query.data;
    $[17] = query.error;
    $[18] = query.isError;
    $[19] = query.isSuccess;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  useEffect(t6, t7);
  return query;
};
export default useGetOnboardingConfig;